import RequestForm from "@/pages/contact/RequestForm";
import { GENERAL_CONTACT_FORM } from "@/pages/contact/requestFormsContent";

export default function GeneralContactRequest() {
  return <RequestForm spec={GENERAL_CONTACT_FORM} />;
}
